<!-- Gestão completa (Marcas) do cliente, reusada em modo embutido (contexto). -->
<app-marca *ngIf="montado"
  [embutido]="true"
  [empresaContextoId]="clienteEmpresaId">
</app-marca>
